import { Icon, Select, Portal, createListCollection, useSlotRecipe, Card } from '@chakra-ui/react';
import { CSSProperties, useContext } from 'react';
import { Layers } from 'react-feather';
import { GraphLayout, GraphViewContext } from './Index';
import { selectRecipe } from '@/theme';
import QuickFilter from './controls/QuickFilter';

export default function LayoutSwitcher(props: {
  style: CSSProperties;
  layout: GraphLayout;
  setLayout: (layout: GraphLayout) => void;
}) {
  const layoutMapping: Array<{ label: string; value: GraphLayout }> = [
    { label: 'Timeline Graph', value: 'TIMLINE_LAYOUT' },
    // { label: 'Force Graph', value: 'FORCE_DIRECTED_LAYOUT' },
    { label: 'List View', value: 'LIST_LAYOUT' },
  ];

  const recipe = useSlotRecipe({ recipe: selectRecipe });
  const style = recipe();

  const graphView = useContext(GraphViewContext);
  const layoutOptions = createListCollection({
    items: layoutMapping,
  });
  return (
    <Card.Root
      style={{
        ...props.style,
      }}
    >
      <Select.Root
        width={'100%'}
        value={[graphView.layout]}
        borderRadius="0.375rem"
        background="cardDefault"
        _hover={{ bg: 'cardHover', transition: 'background-color 0.2s' }}
        _focus={{ bg: 'cardActive', transition: 'background-color 0.2s' }}
        onValueChange={(e) => {
          props.setLayout(e.value[0]);
        }}
        collection={layoutOptions}
      >
        <Select.Control css={style.control}>
          <Select.Trigger css={style.trigger}>
            <Icon color="secondaryText">
              <Layers />
            </Icon>
            <Select.ValueText color="secondaryText" fontSize="14px" />
            <Select.Indicator />
          </Select.Trigger>
        </Select.Control>
        <Portal>
          <Select.Positioner>
            <Select.Content background="cardDefault">
              {layoutOptions.items.map((layoutOption: { label: string; value: string }) => {
                return (
                  <Select.Item
                    key={layoutOption.value}
                    value={layoutOption.value}
                    item={layoutOption}
                    css={{
                      '&[data-state="checked"]': {
                        background: 'cardActive',
                      },
                    }}
                    color="secondaryText"
                    _focus={{ bg: 'cardDefault' }}
                    _hover={{ bg: 'cardHover', transition: 'background-color 0.2s' }}
                    _active={{ bg: 'cardActive', transition: 'background-color 0.2s' }}
                  >
                    {layoutOption.label}
                    <Select.ItemIndicator />
                  </Select.Item>
                );
              })}
            </Select.Content>
          </Select.Positioner>
        </Portal>
      </Select.Root>

      {props.layout !== 'LIST_LAYOUT' ? (
        <QuickFilter style={{ position: 'absolute', top: '50px', left: '0px' }} />
      ) : (
        <></>
      )}
      
    </Card.Root>
  );
}
